export default "__VITE_ASSET__DaKTJZQQ__"